module.exports = __webpack_public_path__ + "img/img_new_top5.4ca29618.png";